import { Paper, SimpleGrid, TextInput } from '@mantine/core'
import type { UseFormReturnType } from '@mantine/form'
import { useTranslation } from 'react-i18next'
import { IconUsers } from '@tabler/icons-react'
import type { RegisteredVisitor } from '../types'
import { inputStyles } from '../styles'
import { SectionHeader } from './section-header'

interface CompanionDetailsSectionProps {
  form: UseFormReturnType<RegisteredVisitor, (values: RegisteredVisitor) => RegisteredVisitor>
  isSmallDevice: boolean
}

export function CompanionDetailsSection({ form, isSmallDevice }: CompanionDetailsSectionProps) {
  const { t } = useTranslation()

  return (
    <Paper p={isSmallDevice ? 'md' : 'xl'} radius="md" sx={{ background: '#fff', border: '1px solid #e5e7eb' }}>
      <SectionHeader icon={<IconUsers size={16} />} title={t('register.companion')} />

      <SimpleGrid cols={isSmallDevice ? 1 : 2} spacing={12}>
        <TextInput withAsterisk sx={inputStyles} label={t('visitor.firstName')} placeholder={t('visitor.firstName')} {...form.getInputProps('companions.0.firstName')} />
        <TextInput withAsterisk sx={inputStyles} label={t('visitor.lastName')} placeholder={t('visitor.lastName')} {...form.getInputProps('companions.0.lastName')} />
      </SimpleGrid>
    </Paper>
  )
}
